require('knacss/sass/knacss.scss');

import 'slick-slider/slick/slick.css';
import '../sass/app.scss';

import $ from 'jquery';
global.$ = global.jQuery = $;

import 'slick-slider';

require('./front/components/all');
require('./front/form/all');
require('./front/pages/all');
require('../../vendor/maier/front-common-bundle/Resources/assets/js/website/maier_main/base');

// Temporary from 20th may (to remove 3rd june 2025: useless)
let currentDate = new Date();
let gShockBoutiqueOpenDate = new Date('06/03/2025'); // 3rd june
if (-1 === window.location.href.search('ab602ffd19922904e03dabe6ebc128de') && currentDate.getTime() < gShockBoutiqueOpenDate.getTime()) {
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.maier-section-shops-list-item:nth-child(5)').forEach(function (section) {
            console.log(section);
            section.style.display = 'none';
        });
    })

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.menu-maier-spirit ul li:nth-child(8)').forEach(function (section) {
            section.style.display = 'none';
        });
    })
}